module.exports = __webpack_public_path__ + "static/media/value-prop-2.77cf10f6.png";